import { render, staticRenderFns } from "./searchIpfcExact.vue?vue&type=template&id=a2be1c1c"
import script from "./searchIpfcExact.vue?vue&type=script&lang=js"
export * from "./searchIpfcExact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports